<div class="sh-form-group" [class.-sh-is-invalid]="invalid" [class]="formGroupStyling">
    <sh-form-label
        [label]="label"
        [required]="required"
        [helpText]="helpText"
        [for]="id"
        [labelIcons]="labelIcons"
        [actionItems]="labelActionItems"
    ></sh-form-label>

    <ng-content select="[slot='inputPrefix']"></ng-content>

    @if (currentActionItems) {
        <div class="sh-input-field-with-action">
            <ng-container *ngTemplateOutlet="inputField"></ng-container>
            @for (item of currentActionItems; track item) {
                <sh-action-item [item]="item" class="sh-action-group__item"> </sh-action-item>
            }
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="inputField"></ng-container>
    }

    <ng-template #inputField>
        <ng-content></ng-content>
    </ng-template>

    @if (invalid && errorMsg) {
        <p [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
    }
</div>
